export default "__VITE_ASSET__DREh2wrq__"